// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__36w2x","content":"RecentSearches_content__2qpV_"};